import React from 'react'

export default function InputElementWrapper({children}) {
  return (
    <div className="col-span-12 rounded-lg bg-white p-2 sm:col-span-6 md:col-span-4 lg:col-span-3">
        {children}
    </div>
  )
}
